import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import { differenceInDays } from "date-fns";
import MultiRoomSelect from "../../Selects/MultiRoomSelect";
import ErrorHelper from "../../Errors/ErrorHelper";

class HoldBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ["room_id_type"])}
        {this.renderHoldForm()}
      </div>
    );
  }

  renderHoldForm() {
    var dateFormat = DateHelper.rubyToDateFNS(this.props.date_format);
    var diffInDays = differenceInDays(
      this.props.check_out_date,
      this.props.check_in_date
    );

    return (
      <div>
        <div className="row form-group">
          <div className="col-lg-4">
            <label>{I18n.t("begins")}*</label>
            <DatePickerInput
              selectedDate={this.props.check_in_date || ""}
              dateFormat={dateFormat}
              onChange={this.onChangeStartDate}
            />
          </div>
          <div className="col-lg-4">
            <label>{I18n.t("ends")}*</label>
            <DatePickerInput
              selectedDate={this.props.check_out_date || ""}
              dateFormat={dateFormat}
              onChange={this.onChangeEndDate}
            />
          </div>
          <div className="col-lg-4">
            <label>{I18n.t("room_id_type")}*</label>
            {this.props.is_new ? (
              <MultiRoomSelect
                className={ErrorHelper.renderFieldClasses("room_id_type", this.props.errors)}
                rooms={this.props.rooms}
                room_type={null}
                onChange={this.props.onChangeRooms}
                name="room"
                dateFormat={this.props.date_format}
                AdditionalParams={{
                  check_in_date: this.props.check_in_date,
                  check_out_date: this.props.check_out_date,}}
              />     
              // <SingleRoomSelect
              //   className={this.renderFieldClasses("room_id")}
              //   room={this.props.room}
              //   room_type={null}
              //   onChange={this.props.onChangeRoom}
              //   name="room"
              //   dateFormat={this.props.date_format}
              //   source={"HoldBuilder"}
              //   AdditionalParams={{
              //     check_in_date: this.props.check_in_date,
              //     check_out_date: this.props.check_out_date,
              //   }}
              // />
            ) : (
              <div>
                {this.props.room
                  ? this.props.room.identifier +
                    " (" +
                    this.props.room_type_name +
                    ")"
                  : null}
              </div>
            )}
            {ErrorHelper.renderFieldErrors("room_id_type", this.props.errors)}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8"></div>
          <div className="col-lg-4 text-center">
            {I18n.t("hold_duration")} {diffInDays}{" "}
            {I18n.t(diffInDays === 1 ? "night" : "nights")}
          </div>
        </div>
      </div>
    );
  }

  onChangeStartDate(e) {
    if (this.props.check_out_date && this.props.check_out_date <= e) {
      this.props.onChange('check_out_date', e);
    }

    this.props.onChange('check_in_date', e);
  }

  onChangeEndDate(e) {
    if (this.props.check_in_date && this.props.check_in_date >= e) {
      this.props.onChange('check_in_date', e);
    }

    this.props.onChange('check_out_date', e);
  }
}

export default HoldBuilderGeneral;
